var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalAssessmentCertified = function SvgHospitalAssessmentCertified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C6EF5",
    d: "m13.5 7-1.442-1.66.201-2.197-2.133-.488L9.009.75 7 1.62 4.99.75 3.875 2.649l-2.133.482.2 2.202L.5 7l1.442 1.66-.201 2.203 2.133.488 1.117 1.899L7 12.375l2.01.869 1.116-1.899 2.133-.488-.2-2.196zM5.871 9.81 3.626 7.542 4.5 6.66l1.371 1.387 3.457-3.494.875.88z"
  })));
};
export default SvgHospitalAssessmentCertified;